import React, { useState, useRef } from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Building2, Heart, Briefcase, Users, TrendingUp, Loader2, CheckCircle2, MessageCircle, Mail, Phone } from 'lucide-react';
import { sendViaWeb3Forms } from '../services/web3formsService';
import { saveSubmission } from '../services/databaseService';
export function DonatePage() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    email: '',
    telephone: '',
    message: ''
  });
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.firstName.trim()) {
      alert('Veuillez entrer votre prénom.');
      return;
    }
    if (!formData.lastName.trim()) {
      alert('Veuillez entrer votre nom.');
      return;
    }
    if (!formData.email.trim() || !formData.email.includes('@')) {
      alert('Veuillez entrer une adresse email valide.');
      return;
    }
    setIsProcessing(true);
    try {
      const fields: Record<string, string> = {
        prenom: formData.firstName,
        nom: formData.lastName,
        email: formData.email,
        telephone: formData.telephone,
        organisation: formData.companyName,
        message: formData.message
      };
      await sendViaWeb3Forms({
        type: 'don',
        fields
      });
      setIsProcessing(false);
      setIsSuccess(true);
      window.scrollTo(0, 0);
    } catch (error) {
      console.error('Error submitting donation inquiry:', error);
      setIsProcessing(false);
      alert('Une erreur est survenue. Veuillez réessayer.');
    }
  };
  if (isSuccess) {
    return <Layout data-id="element-826" data-mp="3hfoyuudnjbdt">
        <SEO {...pageSEO.donate} data-id="element-827" data-mp="3he42r0bovkdu" />
        <div className="min-h-[60vh] flex items-center justify-center bg-gray-50 px-4 py-12" data-id="element-828" data-mp="3hh9r2dchui8i">
          <Card className="max-w-md w-full text-center p-10 shadow-lg border-t-4 border-t-[#1E88E5]" data-id="element-829" data-mp="3ve5a8ymglq2a">
            <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-830" data-mp="3rb8oiz1mhdu4">
              <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-831" data-mp="33lecgjp4ntax" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-832" data-mp="2ymkykq5xi0a8">
              Merci pour votre générosité !
            </h2>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-833" data-mp="37pdooq3dk5yh">
              Votre demande a bien été enregistrée. Un membre de l'équipe ADCC
              vous contactera très prochainement pour organiser votre don et
              répondre à vos questions.
            </p>
            <Button onClick={() => {
            setIsSuccess(false);
            setFormData({
              firstName: '',
              lastName: '',
              companyName: '',
              email: '',
              telephone: '',
              message: ''
            });
          }} className="w-full text-lg py-6" data-id="element-834" data-mp="2fw3jvphxl57v">
              Fermer
            </Button>
          </Card>
        </div>
      </Layout>;
  }
  return <Layout data-id="element-835" data-mp="2oiwizkwzr531">
      <SEO {...pageSEO.donate} data-id="element-836" data-mp="2tjk63vi3n1rz" />
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-837" data-mp="2tismlj1s0ui2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-838" data-mp="2eml2sjua5v3b">
          <span className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1 text-sm font-medium text-blue-200 mb-4" data-id="element-839" data-mp="2eonq2w41ta4c">
            Faire un don
          </span>
          <h1 className="text-4xl font-bold mb-4" data-id="element-840" data-mp="136374lyibwhq">Soutenez l'ADCC</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-841" data-mp="187acked6gjl8">
            Votre contribution permet de financer nos actions de formation et
            d'accompagnement vers l'emploi digne au Bénin.
          </p>
        </div>
      </div>

      <div className="bg-gradient-to-b from-[#2C3E50] to-white pb-12" data-id="element-842" data-mp="1jl2jsb4axpma">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-843" data-mp="1eoc25jcumlyr">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 text-white text-center border border-white/20" data-id="element-844" data-mp="19piptu9at106">
            <h2 className="text-2xl font-bold mb-2" data-id="element-845" data-mp="27b6o6kpbdtec">Votre impact concret</h2>
            <p className="text-lg font-semibold" data-id="element-846" data-mp="22d53jvc8pm0r">
              Soutenez l'insertion professionnelle durable.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-847" data-mp="1xg4v5drx476h">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-848" data-mp="1sez3lj9zupyj">
          <Card className="bg-blue-50 border-blue-100" data-id="element-849" data-mp="m07w2wqd86vj">
            <CardContent className="p-6 text-center" data-id="element-850" data-mp="h020j5gz6086">
              <Users className="w-8 h-8 text-[#1E88E5] mx-auto mb-4" data-id="element-851" data-mp="gzaikxgaw10d" />
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-852" data-mp="2snxctmjh4inm">Développer</h3>
              <p className="text-sm text-gray-600" data-id="element-853" data-mp="2xmi58zshhy1i">
                Financer des ateliers de renforcement de capacités de qualité.
              </p>
            </CardContent>
          </Card>
          <Card className="bg-blue-50 border-blue-100" data-id="element-854" data-mp="32js1ayadp7yb">
            <CardContent className="p-6 text-center" data-id="element-855" data-mp="37d3dlexymgxm">
              <Briefcase className="w-8 h-8 text-[#1E88E5] mx-auto mb-4" data-id="element-856" data-mp="3cbejjel4w7ak" />
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-857" data-mp="3cdh8rwegpwe8">Insérer</h3>
              <p className="text-sm text-gray-600" data-id="element-858" data-mp="3gbop4q50kvow">
                Soutenir les dispositifs de placement et mise en relation avec
                employeurs.
              </p>
            </CardContent>
          </Card>
          <Card className="bg-blue-50 border-blue-100" data-id="element-859" data-mp="3qaea4rs7iw9d">
            <CardContent className="p-6 text-center" data-id="element-860" data-mp="1qyv2cgin3u1a">
              <TrendingUp className="w-8 h-8 text-[#1E88E5] mx-auto mb-4" data-id="element-861" data-mp="1r062m6cvmjnn" />
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-862" data-mp="1vxoeo5m6xezv">Suivre</h3>
              <p className="text-sm text-gray-600" data-id="element-863" data-mp="1nvoz5emelt11">
                Accompagner les bénéficiaires après leur placement pour garantir
                la durabilité.
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Impact Statement */}
        <div className="bg-gradient-to-r from-[#1E88E5] to-[#1976D2] rounded-2xl p-8 text-white mb-12" data-id="element-864" data-mp="1svjqfja3ckmm">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-865" data-mp="26v2wm6jcdlwa">
            <div data-id="element-866" data-mp="26syikvrqb6ia">
              <p className="text-3xl font-bold mb-2" data-id="element-867" data-mp="22tze1c9wtbrd">50€</p>
              <p className="text-sm text-blue-100" data-id="element-868" data-mp="22thbjxwnm1b0">
                Finance le matériel pédagogique pour 2 bénéficiaires
              </p>
            </div>
            <div className="border-t md:border-t-0 md:border-l border-white/20 pt-6 md:pt-0" data-id="element-869" data-mp="2blrkzczq62r7">
              <p className="text-3xl font-bold mb-2" data-id="element-870" data-mp="2qiscbfe07vp5">150€</p>
              <p className="text-sm text-blue-100" data-id="element-871" data-mp="2qgxsy5idsbn6">
                Forme et place 1 bénéficiaire
              </p>
            </div>
            <div className="border-t md:border-t-0 md:border-l border-white/20 pt-6 md:pt-0" data-id="element-872" data-mp="355hejozn4mz8">
              <p className="text-3xl font-bold mb-2" data-id="element-873" data-mp="39849hyrlyo0n">500€</p>
              <p className="text-sm text-blue-100" data-id="element-874" data-mp="395i1xz4pw8if">
                Soutient le dispositif de placement pendant 1 mois
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-875" data-mp="305cvbr7cle5b">
          <div className="lg:col-span-2" data-id="element-876" data-mp="2lhrrtw6k9cwv">
            <Card data-id="element-877" data-mp="2lgqhjtxdcug7">
              <CardContent className="p-8" data-id="element-878" data-mp="2lg6wi4cf9pxy">
                <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-879" data-mp="2q9ry06d8521w">
                  Faites un don à l'ADCC
                </h2>
                <p className="text-gray-600 mb-6" data-id="element-880" data-mp="2cj6csb0asg0u">
                  Remplissez ce formulaire et notre équipe vous contactera pour
                  organiser votre contribution.
                </p>
                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-881" data-mp="22jxkrnoztbh4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-882" data-mp="27h7c58vxzx7l">
                    <div data-id="element-883" data-mp="2n0s0omwa3s23">
                      <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-884" data-mp="2myyuf8pkv9um">
                        Prénom *
                      </label>
                      <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleInputChange} required disabled={isProcessing} className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-885" data-mp="2e1esdxjw59iy" />
                    </div>
                    <div data-id="element-886" data-mp="1lbfzfr2kss90">
                      <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-887" data-mp="1l9lcy8bnos2t">
                        Nom *
                      </label>
                      <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleInputChange} required disabled={isProcessing} className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-888" data-mp="16a9163ptk3gm" />
                    </div>
                  </div>

                  <div data-id="element-889" data-mp="xet1h62duu34">
                    <label htmlFor="companyName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-890" data-mp="xe9vmnq0bw5g">
                      Entreprise / Organisation (optionnel)
                    </label>
                    <div className="relative" data-id="element-891" data-mp="9p76yvwyh31g">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-892" data-mp="9nvzal0e3b52">
                        <Building2 className="h-5 w-5 text-gray-400" data-id="element-893" data-mp="1x7gqjvbzm85p" />
                      </div>
                      <input type="text" id="companyName" name="companyName" value={formData.companyName} onChange={handleInputChange} disabled={isProcessing} className="w-full pl-10 rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-894" data-mp="2260c3umo5hxj" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-895" data-mp="1s69e3iywgksp">
                    <div data-id="element-896" data-mp="vod5hgfgi44i">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-897" data-mp="vowlgrljqifw">
                        Email *
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} required disabled={isProcessing} className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-898" data-mp="s5eb1pcq066g" />
                    </div>
                    <div data-id="element-899" data-mp="3vmw7z1qyfss3">
                      <label htmlFor="telephone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-900" data-mp="3vmec4687fgkp">
                        Téléphone
                      </label>
                      <input type="tel" id="telephone" name="telephone" value={formData.telephone} onChange={handleInputChange} disabled={isProcessing} placeholder="+229..." className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-901" data-mp="3mlg99r9i5f3p" />
                    </div>
                  </div>

                  <div data-id="element-902" data-mp="3qr1wo9tiep9s">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-903" data-mp="3qqinpilu7b7w">
                      Votre message (optionnel)
                    </label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleInputChange} disabled={isProcessing} rows={4} placeholder="Précisez le type de soutien que vous souhaitez apporter, le montant envisagé, ou toute question..." className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-904" data-mp="3lz0p317admq3" />
                  </div>

                  <Button type="submit" className="w-full text-lg py-6" disabled={isProcessing} data-id="element-905" data-mp="27qsyvw1s0vvz">
                    {isProcessing ? <>
                        <Loader2 className="w-5 h-5 mr-2 animate-spin" data-id="element-906" data-mp="1f4hxwka9csyn" />
                        Envoi en cours...
                      </> : <>
                        <Heart className="w-5 h-5 mr-2" data-id="element-907" data-mp="1oz9w9qbnzjuh" />
                        Envoyer ma demande de don
                      </>}
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>

          <div className="space-y-6" data-id="element-908" data-mp="3vqoi0eg7gs00">
            <Card className="bg-blue-50 border-none" data-id="element-909" data-mp="3vrraurx394ik">
              <CardContent className="p-6" data-id="element-910" data-mp="3luewi2gziur">
                <div className="flex items-center gap-3 mb-4" data-id="element-911" data-mp="3mw0vhl0xpr9">
                  <div className="p-2 bg-[#1E88E5] rounded-full" data-id="element-912" data-mp="8l7cnxuvqac4">
                    <MessageCircle className="w-5 h-5 text-white" data-id="element-913" data-mp="dkjz4hhu9fe6" />
                  </div>
                  <h3 className="font-bold text-gray-900" data-id="element-914" data-mp="di78zh1xfyq1">Prise de contact</h3>
                </div>
                <p className="text-sm text-gray-600 mb-4" data-id="element-915" data-mp="ihtvyi7k4tc1">
                  Après réception de votre formulaire, un membre de l'équipe
                  ADCC vous contactera personnellement pour discuter des
                  modalités de votre don et répondre à toutes vos questions.
                </p>
                <div className="space-y-3" data-id="element-916" data-mp="11a4k15xjymq3">
                  <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-917" data-mp="11b78z8bbef3d">
                    <Mail className="w-4 h-4 text-[#1E88E5]" data-id="element-918" data-mp="168ftvgnukx8b" />
                    <span data-id="element-919" data-mp="166uxdlhz347t">contact@adcc.africa</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-920" data-mp="2qskyqpsfujf5">
                    <Phone className="w-4 h-4 text-[#1E88E5]" data-id="element-921" data-mp="2lrdrcru7jm90" />
                    <span data-id="element-922" data-mp="2gskb4rnjdh55">+229 01 59 11 13 30</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-gray-50 border-none" data-id="element-923" data-mp="2bvk4aeiv4acz">
              <CardContent className="p-6" data-id="element-924" data-mp="39hhqon0d4zu7">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-925" data-mp="39h83162sj4ro">
                  Déduction fiscale
                </h3>
                <p className="text-sm text-gray-600" data-id="element-926" data-mp="34krdc7fy0ich">
                  L'ADCC étant une association reconnue, vos dons peuvent ouvrir
                  droit à une déduction fiscale selon la législation en vigueur
                  dans votre pays de résidence. Un reçu fiscal vous sera envoyé
                  automatiquement.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </Layout>;
}